import {defineStore} from "pinia"
import {extend} from "@vue/shared"
import {ModalsPendingTimer, ModalsExpiredTimer, ModalsPin, ModalsRegister, ModalsFiscal, ModalsOrderSummary, ModalsInsurance, ModalsChangeTicketHolder} from "#components"

const component = extend({})
type VueComponent = InstanceType<typeof component>

export const useModalStore = defineStore("modal", () => {

    const props = ref({})
    const component = shallowRef<null | VueComponent>(null)

    function $reset() {
        props.value = {}
        component.value = null
    }

    function openModal(payload: {
        component: Component
        props?: object
    }) {
        if (document.body) {
            document.body.style.overflow = "hidden"
        }

        component.value = payload.component
        props.value = payload.props ?? {}
    }

    function closeModal() {
        $reset()

        if (document.body) {
            document.body.style.overflow = "auto"
        }
    }
    function openExpiredTimerModal() {
        openModal({component: ModalsExpiredTimer, props: {}})
    }
    function openPendingTimerModal() {
        openModal({component: ModalsPendingTimer, props: {}})
    }
    function openPinModal() {
        openModal({component: ModalsPin, props: {}})
    }
    function openRegisterModal() {
        openModal({component: ModalsRegister, props: {}})
    }
    function openFiscalModal() {
        openModal({component: ModalsFiscal, props: {}})
    }
    function openSummaryModal() {
        openModal({component: ModalsOrderSummary, props: {}})
    }
    function openInsuranceModal() {
        openModal({component: ModalsInsurance, props: {}})
    }
    function openChangeTicketHolder() {
        openModal({component: ModalsChangeTicketHolder, props: {}})
    }

    return {
        component,
        props,
        closeModal,
        openPendingTimerModal,
        openExpiredTimerModal,
        openRegisterModal,
        openPinModal,
        openFiscalModal,
        openSummaryModal,
        openInsuranceModal,
        openChangeTicketHolder
    }
})
